import { Button } from '@material-tailwind/react';
import * as XLSX from 'xlsx';

const ExportToExcel = ({ data, fileName, parametros, columnas }) => {

  const exportToExcel = () => {
    let dataExcel = [];

    if (columnas && columnas.length > 0) {
      data.forEach(item => {
        let newData = {};
        columnas.forEach(col => {
          if(col.format && typeof col.format === 'function'){
            newData[col.label] = col.format(item[col.value]);
          }else{
            newData[col.label] = item[col.value];
          }
        });
        dataExcel.push(newData);
      });

      const worksheet = XLSX.utils.json_to_sheet(dataExcel);
      
      // Ajustar ancho de columnas basado en el header
      const wscols = columnas.map(c => ({ wch: Math.max(c.label.length + 10, 15) }));
      worksheet['!cols'] = wscols;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    } else {
      data.map(item => {
        let newData = {
          Iglesia: item.iglesia,
          Período: item.periodo,
          Condición: item.aporte,
          Comprobante: item.comprobante,
          Monto: item.monto
        }

        dataExcel.push(newData);
      })
      // Crear la hoja de cálculo desde un arreglo de datos
      const worksheet = XLSX.utils.json_to_sheet(dataExcel, { origin: 'A8' }); // Los datos comenzarán en la fila 5

      // Agregar encabezados manualmente (antes de los datos)
      XLSX.utils.sheet_add_aoa(worksheet, [
        ["Ministro:", !parametros.id_obrero || parametros.id_obrero == '-1' ? 'Todas' : data[0].obrero],           // Título
        ["Iglesia:", !parametros.id_iglesia || parametros.id_iglesia == '-1' ? 'Todas' : data[0].iglesia],
        ["Dirección:", !parametros.id_iglesia || parametros.id_iglesia == '-1' ? 'Todas' : data[0].locacion],
        ["Región:", !parametros.id_region || parametros.id_region == '-1' ? 'Todas' : data[0].region_obr],
        ["Distrito:", !parametros.id_distrito || parametros.id_distrito == '-1' ? 'Todas' : data[0].distrito_igl],
        ["Fecha del Reporte:", new Date().toLocaleDateString()], // Información adicional (fecha, etc.)
      ], { origin: 'A1' }); // Empieza en A1 (primera celda)

      // Ancho de columnas
      worksheet['!cols'] = [
        { wch: 30 },
        { wch: 20 },
        { wch: 25 },
        { wch: 50 },
        { wch: 20 }
        // Añade más columnas si es necesario
      ];

      // Crear un nuevo libro de trabajo
      const workbook = XLSX.utils.book_new();

      // Añadir la hoja al libro
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Descargar el archivo
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }
  };

  return (
    <Button variant="gradient" className="flex ml-2 items-center gap-3" onClick={exportToExcel}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-4 w-4/"
            >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
            />
        </svg>
      Exportar Excel
    </Button>
  );
};

export default ExportToExcel;
